import './LegalPages.css';

export const TermsPage = () => (
  <LegalPageLayout title="Terms of Service" lastUpdated="March 2024">
    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using Omini Bridge services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
    </section>
    <section>
      <h2>2. Service Description</h2>
      <p>Omini Bridge provides a non-custodial cryptocurrency exchange platform. We do not hold your funds at any time during the exchange process.</p>
    </section>
    <section>
      <h2>3. User Responsibilities</h2>
      <p>You are responsible for ensuring the accuracy of wallet addresses and transaction details. Cryptocurrency transactions are irreversible.</p>
    </section>
    <section>
      <h2>4. Prohibited Activities</h2>
      <p>You may not use our services for any illegal activities, including but not limited to money laundering, fraud, or sanctions violations.</p>
    </section>
    <section>
      <h2>5. Limitation of Liability</h2>
      <p>Omini Bridge is not liable for losses due to user error, network issues, or factors outside our control.</p>
    </section>
  </LegalPageLayout>
);

export const PrivacyPage = () => (
  <LegalPageLayout title="Privacy Policy" lastUpdated="March 2024">
    <section>
      <h2>1. Information We Collect</h2>
      <p>We collect minimal information necessary to process transactions, including wallet addresses and transaction hashes. We do not collect or store private keys.</p>
    </section>
    <section>
      <h2>2. How We Use Information</h2>
      <p>Transaction data is used solely for processing exchanges and maintaining service quality. We do not sell your data to third parties.</p>
    </section>
    <section>
      <h2>3. Data Security</h2>
      <p>We implement industry-standard security measures to protect your information. All data is encrypted in transit and at rest.</p>
    </section>
    <section>
      <h2>4. Third-Party Services</h2>
      <p>We may use third-party services for analytics and payment processing. These services have their own privacy policies.</p>
    </section>
    <section>
      <h2>5. Your Rights</h2>
      <p>You have the right to request deletion of your personal data, subject to legal retention requirements.</p>
    </section>
  </LegalPageLayout>
);

export const CookiesPage = () => (
  <LegalPageLayout title="Cookie Policy" lastUpdated="March 2024">
    <section>
      <h2>1. What Are Cookies</h2>
      <p>Cookies are small text files stored on your device that help us provide and improve our services.</p>
    </section>
    <section>
      <h2>2. How We Use Cookies</h2>
      <p>We use cookies for essential site functionality, analytics, and to remember your preferences.</p>
    </section>
    <section>
      <h2>3. Types of Cookies</h2>
      <p><strong>Essential:</strong> Required for basic site functionality.<br />
         <strong>Analytics:</strong> Help us understand how visitors interact with our site.<br />
         <strong>Preferences:</strong> Remember your settings and choices.</p>
    </section>
    <section>
      <h2>4. Managing Cookies</h2>
      <p>You can control cookies through your browser settings. Note that disabling cookies may affect site functionality.</p>
    </section>
  </LegalPageLayout>
);

export const AMLKYCPage = () => (
  <LegalPageLayout title="AML/KYC Policy" lastUpdated="March 2024">
    <section>
      <h2>1. Our Commitment</h2>
      <p>Omini Bridge is committed to preventing money laundering and terrorist financing. We comply with all applicable AML regulations.</p>
    </section>
    <section>
      <h2>2. KYC Requirements</h2>
      <p>Most exchanges do not require KYC. However, we may request verification for high-value transactions or suspicious activity.</p>
    </section>
    <section>
      <h2>3. Transaction Monitoring</h2>
      <p>We monitor transactions for suspicious patterns and report as required by law.</p>
    </section>
    <section>
      <h2>4. Prohibited Jurisdictions</h2>
      <p>We do not provide services to residents of sanctioned countries or individuals on sanctions lists.</p>
    </section>
    <section>
      <h2>5. Record Keeping</h2>
      <p>We maintain transaction records as required by applicable laws and regulations.</p>
    </section>
  </LegalPageLayout>
);

// Layout component for legal pages
const LegalPageLayout = ({ title, lastUpdated, children }) => (
  <div className="legal-page">
    <div className="legal-container">
      <div className="legal-header">
        <h1>{title}</h1>
        <span className="last-updated">Last Updated: {lastUpdated}</span>
      </div>
      <div className="legal-content">
        {children}
      </div>
      <div className="legal-footer">
        <p>If you have any questions about these policies, please <a href="/contact">contact us</a>.</p>
      </div>
    </div>
  </div>
);

export default LegalPageLayout;
